import { ProductStockHistory } from 'domains/management/products/models'
import React from 'react'
export interface StockHistoryContext<T extends object = any> {
  stockHistories: ProductStockHistory[]
}

export default React.createContext<StockHistoryContext<any>>({
  stockHistories: [],
})
